import { gql } from '@apollo/client';
import { AssetWithDimensionsFragment } from '../../graphql/fragments/Asset';

export const HeaderBlockFragment = gql`
  fragment HeaderBlockFragment on HeaderBlock {
    ... on HeaderBlock {
      backgroundColor
      backgroundDesktopImage {
        ...AssetWithDimensionsFragment
      }
      backgroundMobileImage {
        ...AssetWithDimensionsFragment
      }
      content
      ctas {
        text
        url
      }
      customBackgroundColor
      headerBlockHeader: header
      id
      textAlignment
      textColor
      title
      headerBlockLayout: layout
      verticalAlignment
    }
  }
  ${AssetWithDimensionsFragment}
`;

export default {};
